import { useState } from "react";
import { createBusinessLead } from "../../../api/leads.service";

type Props = {
  businessPhone: string;
  instagramBusinessId: string;
  onClose: () => void;
  onCreated: (conversationId: string) => void;
};

export default function CreateLeadDialog({ businessPhone, instagramBusinessId, onClose, onCreated }: Props) {
  const [name, setName] = useState("");
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [instagramId, setInstagramId] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    const trimmed = name.trim();
    if (!trimmed) {
      setError("Type a name.");
      return;
    }
    if (!businessPhone) {
      setError("This business has no WhatsApp number yet.");
      return;
    }
    setSaving(true);
    setError("");
    try {
      const result = await createBusinessLead({
        businessId: businessPhone,
        instagramBusinessId,
        name: trimmed,
        whatsappNumber,
        instagramId,
      });
      if (!result?.success || !result.conversationId) {
        setError(result?.error || "Could not create the lead.");
        return;
      }
      onCreated(result.conversationId);
    } catch {
      setError("Could not create the lead.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4" onClick={onClose}>
      <div className="w-full max-w-md rounded-xl bg-white p-5 shadow-lg" onClick={(event) => event.stopPropagation()}>
        <h3 className="text-lg font-semibold text-gray-900">Create lead</h3>
        <p className="mt-1 text-sm text-gray-500">This person is saved for this business. Their messages open after you select them.</p>
        <label className="mt-4 block text-sm text-gray-700">
          Name
          <input value={name} onChange={(event) => setName(event.target.value)} className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm" />
        </label>
        <label className="mt-3 block text-sm text-gray-700">
          WhatsApp number
          <input value={whatsappNumber} onChange={(event) => setWhatsappNumber(event.target.value)} placeholder="Optional" className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm" />
        </label>
        <label className="mt-3 block text-sm text-gray-700">
          Instagram
          <input value={instagramId} onChange={(event) => setInstagramId(event.target.value)} placeholder="Optional" className="mt-1 w-full rounded-lg border border-gray-200 px-3 py-2 text-sm" />
        </label>
        {error ? <p className="mt-3 text-sm text-red-600">{error}</p> : null}
        <div className="mt-4 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="rounded-lg px-4 py-2 text-sm text-gray-600">Cancel</button>
          <button type="button" onClick={save} disabled={saving} className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-medium text-white disabled:opacity-60">
            {saving ? "Creating..." : "Create"}
          </button>
        </div>
      </div>
    </div>
  );
}
